import { render, staticRenderFns } from "./BuscarReferidosComponent.vue?vue&type=template&id=5d2a0564"
import script from "./BuscarReferidosComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscarReferidosComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports